import {
    Gutters,
    MainButton,
    Typography,
    useIpInfo,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { FC, useCallback, useEffect, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../i18n/i18next'
import { bs, useBoundStore } from '../../state/bound.store'
import { useEphemeralStore } from '../../state/useEphemeralStore'
import { HotelPreviewCard } from './hotelPreviewCard'

export const HotelEditAdvert: FC = () => {
    const { advertData, getAdvertData, showBookingService, onEnterBookPage } =
        useEphemeralStore(
            useShallow((s) => ({
                advertData: s.advertData,
                getAdvertData: s.getAdvertData,
                showBookingService: s.showBookingService,
                onEnterBookPage: s.onEnterBookPage,
            }))
        )

    const ipInfo = useIpInfo()

    const init = useCallback(() => {
        if (!showBookingService) {
            return
        }
        const genInfo = bs().getEventInfoV2()

        if (genInfo && genInfo.data && genInfo.data.OSMAddress) {
            getAdvertData([
                genInfo.data.OSMAddress.lon,
                genInfo.data.OSMAddress.lat,
            ])
        }
    }, [getAdvertData, showBookingService])

    useEffect(() => {
        init()
    }, [init])

    const hotelsInList: boolean = useMemo(() => {
        const sectionV2 = useBoundStore
            .getState()
            .getSectionV2FromSectionIdFromSelectedItinerary(3)

        if (
            sectionV2 &&
            sectionV2.data &&
            sectionV2.data.hotels &&
            sectionV2.data.hotels.length > 0
        ) {
            return true
        }
        return false
    }, [])

    function onClick() {
        const eventInfoV2 = bs().getEventInfoV2()
        if (!eventInfoV2 || !eventInfoV2.data) {
            return null
        }
        onEnterBookPage(eventInfoV2.data, ipInfo)

        window.pushPath('/edit/hotelbooking/search')
    }

    if (!showBookingService) {
        return null
    }

    return (
        <Gutters topPadding="8px">
            <Stack spacing="8px">
                <MainButton
                    onClick={onClick}
                    variant="secondary"
                    text={i18n.t('edit-itinerary.section.bookHotel')}
                    icon="Hotel"
                    iconPosition="left"
                />
                <MainButton
                    text={i18n.t('booking.addRes')}
                    variant="secondary"
                    onClick={() => {
                        window.pushPath('/edit/hotelbooking/return')
                    }}
                    icon="Billing"
                    iconPosition="left"
                />
                {!hotelsInList &&
                    (advertData?.SPHotelInfoShort ?? []).length > 0 && (
                        <Box display={'grid'} onClick={onClick} gap={'16px'}>
                            <Typography variant="bodyBold">
                                {i18n.t('booking.featured')}
                            </Typography>
                            {advertData?.SPHotelInfoShort.map(
                                (hotelData, index) => {
                                    return (
                                        <HotelPreviewCard
                                            hotelData={hotelData}
                                            key={'hotelAdvert' + index}
                                        />
                                    )
                                }
                            )}
                            <Box height={'32px'} />
                        </Box>
                    )}
            </Stack>
        </Gutters>
    )
}
